import React, { useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

interface ActionableDisabledWrapperProps {
  children: React.ReactElement;
  disabled: boolean;
  reason?: string;
  disabledReasonTitle?: string;
}

const ActionableDisabledWrapper: React.FC<ActionableDisabledWrapperProps> = ({
  children,
  disabled,
  reason = 'This action is currently disabled.',
  disabledReasonTitle = 'Action Disabled'
}) => {
  const [open, setOpen] = useState(false);

  // If enabled, just return the children (preserving original behavior/refs)
  if (!disabled) {
    return children;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(true);
  };

  return (
    <>
      <div 
        onClick={handleClick} 
        style={{ display: 'inline-block', cursor: 'not-allowed' }}
      >
        {/* Clone element to ensure style prop merges if needed, or just wrap it. 
            Wrapping is safer for pointer-events. 
            We ensure the child has pointer-events: none style to let the click pass to the div? 
            Or just capture on the div. MUI buttons with disabled prop usually have pointer-events: none.
         */}
        <div style={{ pointerEvents: 'none' }}>
           {children}
        </div>
      </div>
      <Snackbar 
        open={open} 
        autoHideDuration={3000} 
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ zIndex: 2000 }}
      >
        <Alert severity="warning" sx={{ width: '100%' }}>
          <strong>{disabledReasonTitle}:</strong> {reason}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ActionableDisabledWrapper;
